import { downloadAttachment, prepareAttachmentUntilReady } from '@/api/emails';
import type { ComposeAttachment } from '@/types/compose';

/**
 * The bytes behind a composer attachment. A freshly picked file is still local;
 * once a draft save (or a Forward seed) turns it into a server attachment it is
 * fetched from the message that owns it.
 */
export async function getComposeAttachmentBlob(
  attachment: ComposeAttachment,
  options: { preview?: boolean } = {},
): Promise<Blob> {
  if (attachment.file) {
    return attachment.file;
  }
  const { remoteId, sourceEmailId, sourceAccountId } = attachment;
  if (!remoteId || !sourceEmailId || !sourceAccountId) {
    throw new Error(`Attachment "${attachment.name}" has no local file and no owning message`);
  }
  await prepareAttachmentUntilReady(sourceAccountId, sourceEmailId, remoteId);
  const { blob } = await downloadAttachment(sourceAccountId, sourceEmailId, remoteId, null, options);
  return blob;
}
